import { SxProps } from "@mui/material";
import { titleStyle } from "../customerManagement/customerStepStyles";

export const nameStyle: SxProps = {
  ...titleStyle,
  fontFamily: "Poppins",
  fontSize: {
    xs: "16px",
    sm: "24px",
  },
  mt: 0,
};

export const labelStyle = (isMobile: boolean) => ({
  fontSize: isMobile ? "12px" : "14px",
  "&.MuiTableCell-root.MuiTableCell-root": {
    padding: "18px 0",
    width: "26%",
  },
});
export const cellStyle = (field: string, isMobile: boolean) => ({
  fontSize: isMobile ? "10px" : field === "orderId" ? "12px" : "14px",
  "&.MuiTableCell-root.MuiTableCell-root": {
    padding: "18px 0",
  },
});
export const addNewButtonStyle: SxProps = {
  color: "#333",
  borderColor: "#000",
  fontSize: "14px",
  fontFamily: "Poppins",
  fontWeight: 600,
  borderRadius: "16px",
  height: "40px",
  width: "120px",
};

export const grandTotalStyle: SxProps = {
  fontFamily: "Poppins",
  fontWeight: "600",
  fontSize: {
    xs: "14px",
    sm: "16px",
  },
  color: "#2F4DDB",
  whiteSpace: "nowrap",
};

export const grandTotalAmountStyle = (positive: boolean) =>
  ({
    ...grandTotalStyle,
    color: positive ? "#FF0000" : "#00B207",
  }) as SxProps;

export const grandTotalMobVer: SxProps = {
  backgroundColor: "#fff",
  borderRadius: "15px",
  boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
  paddingX: "20px ",
  mt: "8px",
  mb: "20px",
};

export const paginationMobVer = (isMobile: boolean): SxProps => ({
  "& .MuiPaginationItem-root": {
    fontSize: isMobile ? "12px" : "14px",
  },
  "& .MuiPagination-ul": {
    flexWrap: "nowrap",
  },
});
